export type CompanyData = {
  company: { [key: string]: string }
  document: File | null
  agreements: {[key: string]: any}
}

export enum CompanyRegistrationStep {
  Greeting,
  PowerOfAttorney,
  CompanyDataFilling,
  EmailValidation,
  FinishRegistration,
}
